import { post } from "api/helper";
import { ProcessedApiResponse } from "api/interfaces";

interface DemonstrationParams {
  email: string;
  name?: string;
  phone?: string;
  message?: string;
  recaptchaToken: string;
  productId: number;
}

export const registerForDemonstration = (
  params: DemonstrationParams
): Promise<ProcessedApiResponse> => {
  return post("v1/demonstrations", params);
};
